import setGlobalState from '../redux/setGlobalState';
import {accountInitialState} from '../redux/account/accountReducer';

export default function changeAccount(newAccount={}) {
    const mergeAccount = Object.assign({...accountInitialState}, newAccount);
    setGlobalState('account', mergeAccount);
}
